export default "__VITE_ASSET__qedTs3O1__"